import { useState, useEffect } from 'react';
import { decodeToken } from 'utils';


/**
 * @hook useAuthorization
 * @description
 * Hook personalizado que extrae los roles del usuario a partir del token JWT almacenado
 * en el localStorage bajo la clave `user`. Este hook es útil para controlar el acceso
 * a ciertas secciones o componentes de la aplicación según el rol del usuario.
 *
 * @returns {Array<string>} Arreglo con los roles del usuario. Si no hay usuario, retorna un arreglo vacío.
 */
function useAuthorization() {
	const [userRoles, setUserRoles] = useState([]);

	useEffect(() => {
		/**
		 * Extrae y decodifica el token desde localStorage para obtener el rol del usuario.
		 * Si no existe token, se deja el estado de roles vacío.
		 */
		const checkAuthorization = () => {
			const userFromLocalStorage = localStorage.getItem('user');

			if (userFromLocalStorage) {
				const role = decodeToken(JSON.parse(userFromLocalStorage).token).user_role;
				setUserRoles([role]); // Se devuelve en un array por si en el futuro se soportan múltiples roles
			} else {
				setUserRoles([]);
			}
		};

		checkAuthorization();

		// No requiere limpieza de efectos secundarios
		return () => {};
	}, []);

	return userRoles;
}

export default useAuthorization;